export const submissionTarget = {
    id: '',
    employeeId: '',
    employeeNumber: '',
    employeeName: '',
    target: '',
}

// export const submissionTargetDetail = {
//     id: '',
//     firstName: '',
//     lastName: '',
//     email: '',
//     departmentName: '',
//     isVerified: false,
//     isVerifiedEmail: false,
//     createdAt : moment().format('YYYY-MM-DD'),
// }